const { get, omit, pick, isEmpty } = require('lodash');

const { entries } = Object;
const statuses = {
  received: { label: '入荷検品済み', color: 'success', },
  pending: { label: '保留中', color: 'warning', },
  shelved: { label: '入庫済み', color: 'info', },
  picked: { label: '出庫済み', shippingColor: 'lightgray', },
  shipped: { label: '出荷済み', shippingColor: 'lightgray', },
};

const adminFields = ({ values, type, } = {}) => {
  return {
    status: {
      label: 'ステータス',
      type: 'select',
      options: entries(statuses).map(([k, _]) => ({ label: _.label, value: k })),
    },
  };
};

module.exports = {
  statuses,
  adminFields,
};
